import { Resource } from "../domain/deliveries";
import { getResourcesService } from "../infrastructure/services/getResourcesService";

export const getResources = {
  async execute(): Promise<Resource[]> {
    return await getResourcesService.execute();
  },
};


